import React from 'react'
import { BracketDivider, GamesCol } from './styles'
import type { EventGQL } from '../../../Api'
import { MatchupBox } from './MatchupBox'
import { playoffEventIds } from '../utils'
import { Spacer } from '../../Layout/Spacers/Spacers.styles'

type MatchupProps = {
  events: EventGQL[]
}

export const SemisBottom: React.FC<React.PropsWithChildren<MatchupProps>> = ({
  events,
}) => {
  const semiEvent = events.find((ev) => ev.id === playoffEventIds.s2)
  return (
    <>
      <GamesCol>
        {semiEvent && <MatchupBox key={semiEvent.slugname} event={semiEvent} />}
      </GamesCol>
      <GamesCol>
        <BracketDivider>
          <span></span>
        </BracketDivider>
        <Spacer h={80} />
      </GamesCol>
    </>
  )
}
